import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

const appName = "@@quicksearchbar/"

const loadUserActions = makePieActionObjs("load", "userActions")
const loadSearchResults = makePieActionObjs("load", "searchResults")
const postSavedSearch = makePieActionObjs("post", "safedSearch")
const postUserAction = makePieActionObjs("post", "userAction")
const postFavoritedUserAction = makePieActionObjs("postAndFavorite", "userAction")
const unfavoriteUserActions = makePieActionObjs("unfavorite", "userActions")

export const loadUserActionsTypes = prependAppName(appName, loadUserActions.pieDict)
export const loadSearchResultsTypes = prependAppName(appName, loadSearchResults.pieDict)
export const postSafedSearchTypes = prependAppName(appName, postSavedSearch.pieDict)
export const postUserActionTypes = prependAppName(appName, postUserAction.pieDict)
export const postFavoritedUserActionTypes = prependAppName(appName, postFavoritedUserAction.pieDict)
export const unfavoriteUserActionsTypes = prependAppName(appName, unfavoriteUserActions.pieDict)

export const actionTypes = {
    // register quick search bar in the store
    REGISTER: `${appName}REGISTER`,
    REGISTER_ENUM: `${appName}REGISTER_ENUM`,

    // update query text in the store
    UPDATE_QUERY: `${appName}UPDATE_QUERY`,

    // toggle state of search bar focus
    SET_FOCUS: `${appName}SET_FOCUS`,
    UPDATE_ARROW_INDEX: `${appName}UPDATE_ARROW_INDEX`,
    RESET_ARROW_INDEX: `${appName}RESET_ARROW_INDEX`,
    CLEAR_SEARCH_RESULTS: `${appName}CLEAR_SEARCH_RESULTS`,
    CLEAR_USER_ACTIONS: `${appName}CLEAR_USER_ACTIONS`,
}

export default actionTypes
